import styled, { css } from 'styled-components';
import { FONTS, COLORS, SIZE, FONT_SIZE } from '@app/src/ui';

interface Props {
  error?: boolean;
  background?: string;
}

interface PropsText {
  color?: string;
}

export const Wrapper = styled.div`
  font-family: ${FONTS.OPEN_SANS};
  font-size: ${FONT_SIZE.SHORT};
  padding: 5px 15px;

  background: ${(props: Props) => props.background ? `
    ${props.background};
  ` : `
    ${COLORS.YELLOW};
  `};
  
  ${(props: Props) => props.error && css`
    background: ${COLORS.RED_ERROR};
    color: #fff;
  `}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 420px;
  margin: 0 auto;
  min-height: 44px;

`;

export const IconWrapper = styled.span`
  margin: 2px 0 0 auto;
  cursor: pointer;
`;

export const Text = styled.p`
  color: ${(props: PropsText) => props.color && css`
    ${props.color};
  `}
`;
